// extracted by mini-css-extract-plugin
module.exports = {"container":"Header_container__1VC87","firstLogo":"Header_firstLogo__WHOQg"};